import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { dynamicSort, formatNumber } from "../../../../utils/MainHelper";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";

function WhiteSpaceSummary({
    showZeroInChart
}) {
    const [expandedKeysSaturated, setExpandedKeysSaturated] = useState([]);
    const [expandedKeysWhiteSpace, setExpandedKeyWhiteSpaces] = useState([]);
    const [summaryData, setSummaryData] = useState({});

    const { generateGrid, whitespacePieList } = useSelector((state) => state.reports);

    useEffect(() => {
        const piesObj = {};
        const saturated = [];
        const whitespaces = [];
        const getNeedToDisplay = async () => {
            const prms = [];
            generateGrid.forEach((cat) => {
                if (whitespacePieList[cat.path]?.length) {
                    piesObj[cat.path] = [];
                    whitespacePieList[cat.path].forEach((dd) => {
                        if (dd.isDeepdive) return;
                        const prm = WhiteSpaceServices.getDeepDiveData(dd);
                        prms.push(prm);
                        prm.then((result) => {
                            piesObj[cat.path].push(result);
                        });
                    });
                }
            });
            return Promise.all(prms);
        };
        getNeedToDisplay().then(() => {
            const { list: newListOfCharts } = generateGrid.reduce((acc, cat) => {
                if (acc.checker[cat.path]) return acc;
                acc.list.push(cat);
                acc.checker[cat.path] = true;
                if (piesObj[cat.path]) {
                    piesObj[cat.path].forEach((dd) => {
                        acc.list.push(dd);
                        acc.checker[dd.path] = true;
                    });
                }
                return acc;
            }, { list: [], checker: {} });

            newListOfCharts.forEach((cat) => {
                const children = [...(showZeroInChart ? cat.children : cat.children.filter((d) => d.diff > 0))];
                // if (cat.name.includes(" > ")) {
                //     children = children.splice(0, 10);
                // }
                const tempSaturatedChildren = [];
                const tempWhitespacesChildren = [];
                children.forEach((d) => {
                    const saturatedScore = d.brandSpace;
                    const whitespacesScore = d.diff;
                    if (saturatedScore >= 100) {
                        tempSaturatedChildren.push({
                            name: d.name,
                            score: saturatedScore
                        });
                    } else {
                        tempWhitespacesChildren.push({
                            name: d.name,
                            score: whitespacesScore,
                            targetSize: d.segmentSize
                        });
                    }
                });

                if (tempSaturatedChildren.length) {
                    saturated.push({
                        ...cat,
                        children: tempSaturatedChildren.sort(dynamicSort("-score", true))
                    });
                }
                if (tempWhitespacesChildren.length) {
                    whitespaces.push({
                        ...cat,
                        targetSize: cat.segmentSize,
                        children: tempWhitespacesChildren.sort(dynamicSort("-score", true))
                    });
                }
            });
            setExpandedKeysSaturated(saturated.map((d) => d.key));
            setExpandedKeyWhiteSpaces(whitespaces.map((d) => d.key));
            setSummaryData({
                saturated,
                whitespaces
            });
        });
    }, [generateGrid, whitespacePieList]);

    const expandIcon = ({ expanded, onExpand, record }) => {
        if (!record.children) return <span style={{ padding: "4mm" }} />;
        return (expanded ? (
            <CaretDownOutlined style={{ margin: "0 2mm" }} onClick={(e) => onExpand(record, e)} />
        ) : (
            <CaretRightOutlined style={{ margin: "0 2mm" }} onClick={(e) => onExpand(record, e)} />
        ));
    };

    return (
        <div
            className="d-flex-col gap-1 whitespace-summary"
            name="Summary"
            style={{
                width: "calc(100% - 2mm)",
                height: "auto",
                border: "1px solid #E2E8F0",
                padding: "2mm",
                marginBottom: "2mm",
                borderRadius: "3px",
                backgroundColor: "white"
            }}
        >
            <span
                className="fs-19 fw-700 c-bg-700"
                style={{
                    padding: "4mm"
                }}
            >
                Summary
            </span>
            <div className="d-flex gap-1" style={{ width: "100%", height: "calc(100% - 20mm)" }}>
                <div style={{ width: "calc(40% - 1rem)", height: "100%" }}>
                    <CustomTable
                        className="whitespace-summarytable"
                        style={{
                            height: "100%"
                        }}
                        noCheckbox
                        romanizeParent
                        columns={[{
                            key: "name",
                            title: <b>Saturated Spaces</b>,
                            render: (value, row) => {
                                if (row.children) {
                                    if (value.includes(" > ")) {
                                        return (
                                            <span>
                                                {`${value.split(" > ")[0]} > `}
                                                <b><i>{value.split(" > ")[1]}</i></b>
                                            </span>
                                        );
                                    }
                                    return <b><i>{value}</i></b>;
                                }
                                return value;
                            }
                        }]}
                        dataSource={summaryData?.saturated}
                        pagination={false}
                        expandable={{
                            expandedRowKeys: expandedKeysSaturated,
                            onExpand: (e, d) => {
                                if (e) {
                                    if (!expandedKeysSaturated.includes(d.key)) {
                                        setExpandedKeysSaturated([...expandedKeysSaturated, d.key]);
                                    }
                                } else {
                                    setExpandedKeysSaturated(expandedKeysSaturated.filter((k) => k !== d.key));
                                }
                            },
                            expandIcon
                        }}
                    />
                </div>
                <div style={{ width: "2px", border: "1px solid var(--coolgray-300)" }} />
                <div style={{ width: "calc(60% - 1rem)", height: "100%" }}>
                    <CustomTable
                        className="whitespace-summarytable"
                        style={{
                            height: "100%"
                        }}
                        noCheckbox
                        romanizeParent
                        columns={[{
                            key: "name",
                            title: <b>Whitespaces</b>,
                            render: (value, row) => {
                                if (row.children) {
                                    if (value.includes(" > ")) {
                                        return (
                                            <span>
                                                {`${value.split(" > ")[0]} > `}
                                                <b><i>{value.split(" > ")[1]}</i></b>
                                            </span>
                                        );
                                    }
                                    return <b><i>{value}</i></b>;
                                }
                                return value;
                            }
                        }, {
                            key: "targetSize",
                            title: <b>Monthly Targetable Behaviors</b>,
                            render: (value, row) => formatNumber(value),
                            align: "center"
                        }]}
                        dataSource={summaryData?.whitespaces}
                        pagination={false}
                        expandable={{
                            expandedRowKeys: expandedKeysWhiteSpace,
                            onExpand: (e, d) => {
                                if (e) {
                                    if (!expandedKeysWhiteSpace.includes(d.key)) {
                                        setExpandedKeyWhiteSpaces([...expandedKeysWhiteSpace, d.key]);
                                    }
                                } else {
                                    setExpandedKeyWhiteSpaces(expandedKeysWhiteSpace.filter((k) => k !== d.key));
                                }
                            },
                            expandIcon
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default WhiteSpaceSummary;
